var _ = require('underscore');
module.exports = function(options){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='';

  let {
    priceValue,
    priceDisplayValue
  } = options;

__p+='\n\n<option value="'+
((__t=( priceValue ))==null?'':__t)+
'">'+
((__t=( priceDisplayValue ))==null?'':__t)+
'</option>\n';
return __p;
};



// WEBPACK FOOTER //
// ./templates/price_facet_list_item_mobile.jst.ejs